import { EMPTY_FIELD_PLACEHOLDER } from '@Constants';
import { HrmRequestFormResponse } from '@Types/api/form';
import { RequestListSearchResponse } from '@Types/api/requestList';
import { parseDateTime } from '@Utils/transformDateTime';
import { TypeDict } from 'types';
import { ColumnDataType } from './type';
import { getReason } from './utils';

interface DataSourceMap {
  data: RequestListSearchResponse<HrmRequestFormResponse>;
  findStatus: (statusNum: number) => TypeDict | undefined;
  findRequestType: (statusNum: number) => TypeDict | undefined;
  findDeptProjName: (projDeptID: number, wlId: number) => string | null;
  findReasonType: (statusNum: number) => TypeDict | undefined;
}

export const dataSourceMap = ({
  data,
  findRequestType,
  findStatus,
  findDeptProjName,
  findReasonType,
}: DataSourceMap): Array<ColumnDataType> => {
  if (!data?.content) return [];

  return data?.content?.map((requestItem) => {
    const matchedReqType = findRequestType(requestItem.leaveTypeID)?.codeDesc;
    const matchedDeptProjName = findDeptProjName(
      requestItem.deptProjID,
      requestItem.wlId
    );
    const matchedReasonType = findReasonType(requestItem.groupID)?.codeDesc;
    const matchedStatus = findStatus(requestItem.reqStatusId)?.codeDesc;

    const labels = {
      deptProj: matchedDeptProjName || '',
      reason: matchedReasonType || '',
      remarks: requestItem.remarks || '',
      date: parseDateTime(requestItem.startDate),
      toDate: parseDateTime(requestItem.endDate),
    };
    const reason = getReason(requestItem.leaveTypeID, labels);

    return {
      key: requestItem.requestId,
      requestNo: requestItem.requestId,
      empName: requestItem.empName,
      approverName: requestItem.approverName,
      reqType: matchedReqType || '',
      projDept: matchedDeptProjName || EMPTY_FIELD_PLACEHOLDER,
      createdDate: parseDateTime(requestItem.createdDate),
      reason,
      status: matchedStatus || '',
    };
  });
};
